module.exports = __webpack_public_path__ + "img/상단 텍스트_아이콘.2c3119cc.svg";